import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Block } from "./library/container";
import { ResponsivePicture } from "../../../Shared/components/Image";
export const ImageBlock = (p)=>/*#__PURE__*/ _jsx(Block, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "block block--image block--media container--mg align--center",
            children: /*#__PURE__*/ _jsx("div", {
                className: "block__visual container--s align--center",
                children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                    imgClassName: "block__image",
                    defaultImageUrl: p.imageUrlFallback,
                    cropsPerMedia: [
                        {
                            crops: [
                                {
                                    url: p.imageUrlSmall,
                                    width: 391
                                },
                                {
                                    url: p.imageUrl,
                                    width: 782
                                },
                                {
                                    url: p.imageUrlLarge,
                                    width: 1564
                                }
                            ]
                        }
                    ],
                    width: 782,
                    alt: p.imageAlt
                })
            })
        })
    });
{}